<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('newWeekHistory.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="month-box" v-for="item in menu">
                <div class="month-text" v-if="new Date(item.WeekData[0].startDate) < today">{{ item.month }}</div>
                <div class="week-box">
                    <div class="week"
                         v-for="week in item.WeekData"
                         v-if="new Date(week.endDate) < today"
                         @click="toMonthDesc(week)"
                    >
                        {{ week.beginTime }} — {{ week.endTime }}
                        <img class="to-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
            </div>
            <div class="no-tag">{{ $t('newWeekHistory.no') }}</div>
        </div>
    </div>
</template>

<script>
import {GetMonth} from '@/utils/dateUtils'
import {getQueryVariable} from '@/utils/comment'

export default {
    name: 'weeklyList',
    data() {
        return {
            menu: [],
            startDate: '2022-01',
            endDate: GetMonth(1),
            today: new Date(),
            theme: ''
        }
    },
    mounted() {
        this.initData()
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
    },
    methods: {
        back() {
            this.$router.push({
                name: 'newSportList',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        toMonthDesc(week) {
            let startDate = this.timeFormat(new Date(week.id));
            let endDate = week.endDate
            if (new Date(startDate) < new Date('2023-08-28')) {
                if (window.location.href.indexOf('debug') != -1 || window.location.href.indexOf('localhost') != -1) {
                    window.location.href = 'https://service.beidouwatch.com/bdwatch_web_debug/view/sportWeekly.html?userId=' + this.userId + '&startDate=' + startDate
                } else {
                    window.location.href = 'https://service.beidouwatch.com/bdwatch_web/view/sportWeekly.html?userId=' + this.userId + '&startDate=' + startDate
                }
            } else {
                this.$router.push({
                    name: 'newWeek',
                    query: {
                        startDate,
                        endDate,
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            }
        },
        initData() {
            let arr = []
            let getLastSixMon = this.getMonthBetween(this.startDate, this.endDate)
            for (let i = 0; i < getLastSixMon.length; i++) {
                let res = getLastSixMon[i];
                let id = res.slice(5, 10)
                let WeekData = this.weeks(res)
                let month;
                if (this.$i18n.locale == 'en') {
                    month = res.replace('-', '/')
                } else {
                    month = res.replace('-', '年') + '月'
                }
                let result = {
                    month,
                    WeekData,
                }
                arr.push(result)
            }
            arr.forEach((item, index) => {
                let last = arr[index + 1],
                    first = arr[index],
                    lastData,
                    firstData = first.WeekData[0].endTime
                if (last) {
                    let lastlen = last.WeekData.length - 1
                    lastData = last.WeekData[lastlen].endTime
                }
                if (lastData == firstData) {
                    last.WeekData.pop()
                }

            })
            this.menu = arr.reverse();
            console.log(this.menu)
        },
        getMonthBetween(start, end) {
            var result = [];
            var s = start.split("-");
            var e = end.split("-");
            var min = new Date(start);
            var max = new Date(end);
            // min.setFullYear(s[0], s[1]);
            // max.setFullYear(e[0], e[1]);
            // console.log(this.timeFormat(new Date(start)))
            var curr = min;
            while (curr <= max) {
                var month = curr.getMonth();
                //month=month==0?12:month;
                var str = curr.getFullYear() + "-" + (month);
                var s = curr.getFullYear() + "-0";
                if (str == s) {
                    str = curr.getFullYear() - 1 + "-12";
                }
                result.push(str);
                curr.setMonth(month + 1);
            }
            console.log(result)
            return result;
        },
        time(date) {
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            var d = date.getDate()
            // if (m < 10) m = '0' + m;
            // if (d < 10) d = '0' + d;
            return y + '-' + m + '-' + d
        },
        timeFormat(date) {
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            var d = date.getDate()
            if (m < 10) m = '0' + m;
            if (d < 10) d = '0' + d;
            return y + '-' + m + '-' + d
        },
        weeks(now_month) {
            let {
                time
            } = this
            let week_array = [];
            let today = new Date(Date.parse(now_month));
            let year = today.getFullYear();
            let month = today.getMonth();
            let i = 0;
            let start = new Date(year, month, 1); // 得到当月第一天
            let end = new Date(year, month + 1, 0); // 得到当月最后一天

            // 循环每周最后天叠设置为第一天，直到最后一天小于当月的最后一天
            while (start <= end) {
                const monday = new Date(start.getTime());
                const sunday = new Date(start.getTime());
                let startDate, endDate

                monday.setDate(monday.getDate() + 1 - monday.getDay());
                sunday.setDate(sunday.getDate() + 7 - sunday.getDay());
                let mondayMonth = monday.getMonth()
                startDate = time(monday),
                    endDate = time(sunday)
                if (month == mondayMonth) {
                    let beginTime;
                    let endTime;
                    if (this.$i18n.locale == 'en') {
                        beginTime = startDate.slice(5, 10).replace(/-/g, '/')
                        endTime = endDate.slice(5, 10).replace(/-/g, '/')
                    } else {
                        beginTime = startDate.slice(5, 10).replace('-', '月') + '日';
                        endTime = endDate.slice(5, 10).replace('-', '月') + '日';
                    }
                    week_array.push({
                        startDate,
                        endDate,
                        beginTime,
                        endTime,
                        id: monday.getTime()
                    })
                }
                start = sunday;
            }
            return week_array.reverse();
        }
    },
}
</script>

<style scoped>

.month-text {
    font-size: 14px;
    margin-left: 35px;
    margin-bottom: 15px;
    color: var(--text-color-1);
}

.week-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 6px 6px 6px 6px;
    margin: 0 auto 20px;
    color: var(--text-color-2);
}

.week {
    padding-left: 20px;
    font-size: 15px;
    /*border-bottom: 1px solid #000000;*/
    line-height: 51px;
    position: relative;
}

.to-icon {
    width: 16px;
    position: absolute;
    top: 20px;
    right: 12px;
}

.no-tag {
    font-size: 12px;
    text-align: center;
    margin: 30px auto;
    color: var(--text-color-2);
}
</style>



// WEBPACK FOOTER //
// src/views/report/04weekHistory.vue